/* eslint-disable react-hooks/exhaustive-deps */
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

import { Styles } from './styles';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';

export type PaginationTemplateProps = {
  nextPage?: () => void;
  previousPage?: () => void;
  currentPage?: (num: number) => void;
  handlePageChange?: (num: number) => void;
  page?: number;
  totalPages?: number;
};

const PaginationTemplate: React.FC<PaginationTemplateProps> = ({
  handlePageChange,
  page = 1,
  totalPages = 10,
}) => {
  const setInitialRange = useMemo(() => {
    if (totalPages === 4) return [1, 2, 3, 4];
    if (totalPages > 2) return [1, 2, 3];
    if (totalPages === 2) return [1, 2];
    return [1];
  }, [totalPages]);
  const [pageRange, setPageRange] = useState<number[]>(setInitialRange);

  useEffect(() => {
    const size = pageRange.length;
    if (page > pageRange[size - 1]) {
      if (page === totalPages)
        setPageRange(pageRange.map((pageNum, i) => totalPages - pageRange.length + i + 1));
      else setPageRange(pageRange.map((pageNum) => pageNum + 1));
    }
    if (page < pageRange[0]) {
      if (page === 1) setPageRange(pageRange.map((pageNum, i) => i + 1));
      else setPageRange(pageRange.map((pageNum) => pageNum - 1));
    }
  }, [page]);

  return (
    <Styles>
      {/* Pagination */}
      <ul className="pagination-box list-unstyled list-inline">
        <li
          onClick={() => (handlePageChange && page > 1 ? handlePageChange(page - 1) : null)}
          className="list-inline-item"
        >
          <a>
            <FaAngleDoubleLeft size={16} />
          </a>
        </li>
        {totalPages > 4 && pageRange[2] === totalPages && (
          <>
            <li
              onClick={handlePageChange && (() => handlePageChange(1))}
              className="list-inline-item"
            >
              <a>1</a>
            </li>
            <li className="list-inline-item">
              <a>...</a>
            </li>
          </>
        )}
        {pageRange.map((pageNum) => (
          <li
            key={pageNum}
            onClick={handlePageChange && (() => handlePageChange(pageNum))}
            className={page === pageNum ? 'active list-inline-item' : 'list-inline-item'}
          >
            <a>{pageNum}</a>
          </li>
        ))}
        {totalPages > 4 && pageRange[2] < totalPages && (
          <li className="list-inline-item">
            <a>...</a>
          </li>
        )}
        {totalPages > 4 && pageRange[2] < totalPages && (
          <li
            onClick={handlePageChange && (() => handlePageChange(totalPages))}
            className="list-inline-item"
          >
            <a>{totalPages}</a>
          </li>
        )}
        <li
          onClick={() =>
            handlePageChange && page < totalPages ? handlePageChange(page + 1) : null
          }
          className="list-inline-item"
        >
          <a>
            <FaAngleDoubleRight size={16} />
          </a>
        </li>
      </ul>
    </Styles>
  );
};

export default PaginationTemplate;
